



























































































import { mapActions } from 'vuex';
import Vue from 'vue';
import { AUTH_REQUEST, SSO_CHECK, SSO_URL } from '@/main/store/actionTypes';
import { signInUrl } from '@/main/services/ssoProvider';
import { SSOState } from '@/main/store/authorization/state';

import { httpRequest } from '#services/httpRequest';

import ChangePassword from './ChangePassword.vue';

export default Vue.extend({
	name: 'LoginDialog',
	components: {
		ChangePassword,
	},
	data() {
		return {
			name: '\\',
			password: null,
			checkState: 0,
			SSOState,
		};
	},
	computed: {
		loginFormValid(): boolean {
			const [tenant, name] = this.name.split('\\');
			return !!(tenant?.trim() && name?.trim() && this.password);
		},
		changePassword() {
			return this.$store.state.authorization.resetPassword || this.$store.state.authorization.changePassword;
		},
	},
	mounted() {
		this.ssoCheck();
	},
	methods: {
		...mapActions({
			authRequest: AUTH_REQUEST,
			ssoCheckAction: SSO_CHECK,
			ssoUrl: SSO_URL,
		}),
		async logIn() {
			const loading = this.$loading({ fullscreen: true });

			const { password } = this;

			this.password = null;

			const [tenant, name] = this.name.split('\\');
			httpRequest.setAxiosTenantQuery(tenant);
			await this.authRequest({ Login: name, tenant, Password: password, RememberMe: true });
			loading.close();
		},
		async ssoCheck() {
			const loading = this.$loading({ fullscreen: true });
			if (this.$route.query.identity === 'false') return;
			this.checkState = await this.ssoCheckAction();
			loading.close();
		},
		async ssoLogin() {
			const loading = this.$loading({ fullscreen: true });
			const redirect = this.$route.query.redirect || '';
			this.ssoUrl().then(function (response ){
				if( response){
					window.location.href  = response;
				}
			});
            loading.close();
		},
	},
});
